import ProductUsageTable from './ProductUsageTable'
export default ProductUsageTable
